export const capitalizeSentence = (text) => {
  if (typeof text !== "string" || text.length === 0) return "";
  const firstLetter = text.search(/[a-z]/i);
  if (firstLetter < 0) return text;
  return `${text.slice(0, firstLetter)}${text.charAt(firstLetter).toUpperCase()}${text.slice(firstLetter + 1)}`;
};

export const formatCharacterName = (name) => {
  if (typeof name !== "string") return "";
  return name.replace(/\b[a-z]/gi, (letter) => letter.toUpperCase());
};